import { CALL_API } from "../../middlewares/api";

export const COLLECTION_TERMINATED_LOANS_FETCH_REQUEST =
  "COLLECTION_TERMINATED_LOANS_FETCH_REQUEST";
export const COLLECTION_TERMINATED_LOANS_FETCH_SUCCESS =
  "COLLECTION_TERMINATED_LOANS_FETCH_SUCCESS";
export const COLLECTION_TERMINATED_LOANS_FETCH_ERROR =
  "COLLECTION_TERMINATED_LOANS_FETCH_ERROR";

export function get_terminated_loans() {
  return {
    [CALL_API]: {
      method: "GET",
      endpoint: "/api/admin/debt-agency/loans-suggested-for-da-collection",
      authenticatedRequest: true,
      types: [
        COLLECTION_TERMINATED_LOANS_FETCH_REQUEST,
        COLLECTION_TERMINATED_LOANS_FETCH_SUCCESS,
        COLLECTION_TERMINATED_LOANS_FETCH_ERROR,
      ],
    },
  };
}
